import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import styles from './eventRule.module.scss';

export const EventRule = ({ event }) => {
    const isButtonClicks = event.type === CONVERSION_TYPE.EVENT_BASED;
    const urlEvent = event.urlEvent || event.condition?.value;

    return (
        <div className={styles['section']}>
            <div className={styles['section-title']}>
                <FormattedMessage id="codeless.event.rule.title" defaultMessage="Event rule" />
            </div>
            <div className={styles['section-content']}>
                {isButtonClicks ? (
                    <FormattedMessage
                        id="codeless.event.rule.button"
                        defaultMessage="button text - <strong>`{eventName}`</strong>"
                        values={{ eventName: event.eventName }}
                    />
                ) : (
                    <FormattedMessage
                        id="codeless.event.rule.url"
                        defaultMessage="When someone visits this URL <strong>`{url}`</strong>"
                        values={{ url: urlEvent }}
                    />
                )}
            </div>
        </div>
    );
};
